const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
	list_shop: [],
	total_revenue: 0,
	all_return_orders_for_export: []
};

function reuturnOrderReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_RETURN_ORDER':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_LIST_RETURN_ORDER':
			return {
				...state,
				list: action?.payload?.returnOrders || [],
				totalsize: action?.payload?.totalsize || 0,
				list_shop: action?.payload?.list_shop || [],
				total_revenue: action?.payload?.total_revenue || 0,
			};
		case 'EXPORT_RETURN_ORDER':
			return {
				...state,
				all_return_orders_for_export: action.payload.all_return_orders_for_export
			};
		default:
			return state;
	}
}

export default reuturnOrderReducer;
